import React from 'react'
import { NavLink } from 'react-router-dom'

const Rule = () => {
  return (
    <div>
        <div className='container mt-5'>
            <div className='row'>
                <div className='col-lg-12'>
                <div className="rules-container">
      <div className="breadcrumb">
        <NavLink to="/ludoking"> <span  >Home</span></NavLink> / <span className="breadcrumb-current">Ludo Rules</span>
      </div>
      <h1 className="rules-title">Game Rules:</h1>
      <ol className="rules-list">
        <li>
          On winning, both players have to update their results in the following
          manner:
          <ul>
            <li>
              If you have won the battle, select <strong>"I Won"</strong> option
              and upload the winning screenshot of the game.
            </li>
            <li>
              If you have lost the battle, select <strong>"I Lost"</strong>{" "}
              option.
            </li>
            <li>
              If your battle is not started and your opponent doesn't want to
              play, select <strong>"Cancel"</strong> option.
            </li>
          </ul>
        </li>
        <li>
          A player must record every game, and if any player is hacking or
          cheating in a game, please contact support with video proof.
        </li>
        <li>
          If your game is not started, and if you haven't played a single move
          yourself, please show us a recording of the game as proof. The game
          will be canceled only if you have recorded.
        </li>
        <li>
          If you don't have any proof against player cheating and error in the
          game, then you will be considered as lost for a particular battle.
        </li>
        <li>
          If you haven't moved a single pawn or no pawn is open yet, i.e., all
          pawns are at home, then your game will be canceled.
        </li>
        <li>
        If your opponent leaves match purposely in starting or initial game, and the opponent doesn't have any valid proof of cancellation, you will be awarded a 50 % win.
        </li>
      </ol>
    </div>


    <div>
      <h5 className='my-4'>Commission Rates:</h5>
      <ol className="rules-list">
        <li>Battle below 250₹, 10% commission will be charged on battle amount.</li>
        <li>Battle between 250₹ to 500₹,<strong> flat 25₹ </strong> commission will be charged.    </li>
        <li>Battle above 500₹, 5% commission will be charged on battle amount.  </li>
      </ol>
    </div>





                </div>
            </div>
        </div>
    </div>
  )
}

export default Rule